import {
    formatAdoptionPercent,
    formatCount,
    getAdoptionBadgeClasses,
    getAdoptionBarClasses,
} from './aiPurchaseAnalyticsUtils';

export interface PercentRowProps {
    label: string;
    percent: number;
    denominator: number;
    linkedCount: number;
    totalCount: number;
}

/**
 * Shared adoption-percentage row: label + colour-coded badge + progress bar + raw
 * counts, on a neutral/light background (dark text, pastel red/amber/green badges).
 * Used inside both the state breakdown cards (`StateBreakdownGrid`) and the brand
 * breakdown table cells (`BrandBreakdownGrid`) — both now render on white/near-white
 * card backgrounds, so a single light-mode styling covers both.
 */
export default function PercentRow({
    label,
    percent,
    denominator,
    linkedCount,
    totalCount,
}: PercentRowProps) {
    const clampedPercent = denominator === 0 ? 0 : Math.min(100, Math.max(0, percent));

    return (
        <div>
            <div className="flex items-center justify-between mb-1 gap-2">
                <span className="text-xs text-[#64748b]">{label}</span>
                <span
                    className={`text-xs font-semibold px-2 py-0.5 rounded-full border flex-shrink-0 ${getAdoptionBadgeClasses(
                        percent,
                        denominator
                    )}`}
                >
                    {formatAdoptionPercent(percent, denominator)}
                </span>
            </div>
            <div className="h-1.5 w-full rounded-full overflow-hidden bg-[#f1f5f9]">
                <div
                    className={`h-full rounded-full ${getAdoptionBarClasses(percent, denominator)}`}
                    style={{ width: `${clampedPercent}%` }}
                />
            </div>
            <p className="text-[11px] mt-1 text-[#94a3b8]">
                {formatCount(linkedCount)} of {formatCount(totalCount)}
            </p>
        </div>
    );
}
